import * as t from 'io-ts';
import { meta } from '@/services/api';

export const TemplateCodec = t.type({
  id: t.number,
  title: t.string,
  description: t.union([t.string, t.null]),
  isFeatured: t.boolean,
});

export const TemplateList = t.type({
  data: t.array(TemplateCodec),
  meta,
});

export const TemplateDetail = t.type({
  data: TemplateCodec,
});
